import { TableCell, TableRow, Box, Chip } from "@mui/material";
import { Edit, DeleteOutline } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import * as S from "./styled";
import { useSelector, useDispatch } from "react-redux";
import {
  selectAll,
  DeleteRow,
  UpdateValue,
} from "../../../features/CategorySlice";
import { getFirebaseDataByCreationDate } from "../../../Services/firebase";
import * as categories from "../../../Services/categories";
import { Modal } from "../../../Components/Modal";
import { PrimaryButton } from "../../../Components/Button";
import { LoadingSpinner } from "../../../Components/Loader";
import ReactPaginate from "react-paginate";
import { CaretLeft, CaretRight } from "phosphor-react";
import { TABLES } from "../../../enums/tables";

export default function Index({
  editItem,
  onToastOpen,
  typeFilter,
  subFilter,
}) {
  const query = useSelector((state) => state.query.query_string);
  const queryNum = useSelector((state) => state.query.queryByNumber);
  const categoryData = useSelector(selectAll);
  const dispatch = useDispatch();
  const [formatedData, setFormatedData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [currentQueryNum, setCurrentQueryNum] = useState(queryNum);
  const [activePage, setActivePage] = useState(0);

  async function getDataFromFirebase(collection) {
    const data = await getFirebaseDataByCreationDate(collection);
    dispatch(UpdateValue(data));
  }

  useEffect(() => {
    try {
      getDataFromFirebase(TABLES.CATEGORIES);
    } catch (error) {
      console.error(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    function formatData() {
      setFormatedData(
        categoryData.map((category) => {
          let categoryTranslation = category.collection;

          if (category.collection === "connectroutes") categoryTranslation = "ConnectRoutes";
          if (category.collection === "connectstores") categoryTranslation = "ConnectStores";
          if (category.collection === "connectplaces") categoryTranslation = "ConnectPlaces";
          if (category.collection === "connectguides") categoryTranslation = "ConnectGuides";
          if (category.collection === "connectsales") categoryTranslation = "ConnectSales";
          if (category.collection === "connectmarket") categoryTranslation = "ConnectMarket";

          return { ...category, type: categoryTranslation || category.collection };
        })
      );
    }
    formatData();
  }, [categoryData]);

  useEffect(() => {
    if (formatedData) {
      const normalizedQuery = (query || "").toLowerCase().trim();
      const filtered = formatedData.filter((row) => {
        // Filter by collection type
        if (typeFilter && typeFilter !== "all") {
          const rowCol = (row.collection || "").toLowerCase();
          const rowType = (row.type || "").toLowerCase();
          const filterCol = typeFilter.toLowerCase();
          if (rowCol !== filterCol && rowType !== filterCol) {
            return false;
          }
        }

        // Filter by subcategories presence
        if (subFilter === "with_subs") {
          if (!Array.isArray(row?.subs) || row.subs.length === 0) return false;
        } else if (subFilter === "no_subs") {
          if (Array.isArray(row?.subs) && row.subs.length > 0) return false;
        }

        // Search text query
        if (!normalizedQuery) return true;

        const nameMatch = Object.values(row?.names || {}).some(
          (n) => typeof n === "string" && n.toLowerCase().includes(normalizedQuery)
        );

        const typeMatch =
          row?.collection?.toLowerCase().includes(normalizedQuery) ||
          row?.type?.toLowerCase().includes(normalizedQuery);

        const subMatch =
          Array.isArray(row?.subs) &&
          row.subs.some((sub) => {
            const idMatch = sub?.id?.toLowerCase().includes(normalizedQuery);
            const subNameMatch = Object.values(sub?.names || {}).some(
              (n) => typeof n === "string" && n.toLowerCase().includes(normalizedQuery)
            );
            return idMatch || subNameMatch;
          });

        return nameMatch || typeMatch || subMatch;
      });

      setFilteredData(filtered);
    }
  }, [query, typeFilter, subFilter, formatedData]);

  useEffect(() => {
    setCurrentPage(0);
    setCurrentQueryNum(queryNum);
    setActivePage(0);
  }, [queryNum, query]);

  useEffect(() => {
    setActivePage(currentPage);
  }, [currentPage]);

  if (filteredData) {
    const startIndex = currentPage * currentQueryNum;
    const endIndex = startIndex + currentQueryNum;
    const paginatedData = filteredData.slice(startIndex, endIndex);

    return (
      <>
        {paginatedData.map((row) => {
          return (
            <React.Fragment key={row.id}>
              <ReadOnlyRow
                onToastOpen={onToastOpen}
                data={row}
                setEditId={editItem}
              />
            </React.Fragment>
          );
        })}
        <ReactPaginate
          previousLabel={<CaretLeft size={16} />}
          nextLabel={<CaretRight size={16} />}
          breakLabel={"..."}
          pageCount={Math.ceil(filteredData.length / currentQueryNum)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={(selectedPage) => {
            setActivePage(selectedPage.selected);
            setCurrentPage(selectedPage.selected);
          }}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          activeClassName={"active"}
          forcePage={activePage}
        />
      </>
    );
  }
}

export const ReadOnlyRow = ({ data: row, setEditId, onToastOpen }) => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  function openModal() {
    setIsModalOpen(true);
  }

  async function handleCategoryDelete() {
    try {
      setIsDeleting(true);
      await categories.remove(row);
      dispatch(DeleteRow({ id: row.id }));
      onToastOpen("Success", "success");
    } catch (error) {
      console.error(error);
      onToastOpen("Error", "error");
    } finally {
      setIsDeleting(false);
    }
  }

  function getLocalizedValue(names) {
    if (!names) return "";
    const languagePriority = ["pt", "pt-BR", "en", "en-US", "es", "it", "fr", "zh"];

    for (const language of languagePriority) {
      if (names[language]) {
        return names[language];
      }
    }

    return Object.values(names)[0] || "";
  }

  return (
    <>
      <Modal
        open={isModalOpen}
        onOpenChange={(open) => {
          if (!isDeleting) {
            setIsModalOpen(open);
          }
        }}
        title="Atenção!"
        description={`Tem certeza que deseja deletar "${getLocalizedValue(
          row?.names
        )}"?`}
      >
        <S.ModalContainer>
          <PrimaryButton onClick={() => setIsModalOpen(false)}>
            Cancelar
          </PrimaryButton>

          <PrimaryButton
            onClick={handleCategoryDelete}
            style={{ marginLeft: "auto" }}
          >
            {isDeleting ? <LoadingSpinner /> : "Confirmar"}
          </PrimaryButton>
        </S.ModalContainer>
      </Modal>
      <TableRow key={row?.id}>
        {/* Coluna 1: Tipo (Coleção) */}
        <TableCell style={{ width: "160px" }}>
          <Chip
            label={row?.type}
            size="small"
            style={{
              backgroundColor: "#e0f2fe",
              color: "#0369a1",
              fontWeight: "700",
              fontSize: "0.75rem",
              borderRadius: "6px",
              border: "1px solid #bae6fd"
            }}
          />
        </TableCell>

        {/* Coluna 2: Categoria (Nome) */}
        <TableCell sx={{ minWidth: "200px" }}>
          <S.styledCell>
            <S.Ball bColor={row?.color} />
            <span style={{ fontWeight: "600", color: "#0f172a" }}>{getLocalizedValue(row?.names)}</span>
          </S.styledCell>
        </TableCell>

        {/* Coluna 3: Subcategorias */}
        <TableCell>
          {Array.isArray(row?.subs) && row.subs.length > 0 ? (
            <Box style={{ display: "flex", flexWrap: "wrap", gap: "4px", maxWidth: "320px", alignItems: "center" }}>
              {row.subs.slice(0, 3).map((sub) => (
                <Chip
                  key={sub.id}
                  label={sub.names?.["pt"] || sub.names?.["pt-BR"] || getLocalizedValue(sub.names) || sub.id}
                  size="small"
                  variant="outlined"
                  style={{ fontSize: "0.72rem", height: "22px", borderColor: "#cbd5e1", backgroundColor: "#f8fafc" }}
                />
              ))}
              {row.subs.length > 3 && (
                <Chip
                  label={`+${row.subs.length - 3}`}
                  size="small"
                  style={{ fontSize: "0.72rem", height: "22px", backgroundColor: "#e2e8f0", color: "#334155", fontWeight: "700" }}
                />
              )}
            </Box>
          ) : (
            <span style={{ fontSize: "0.8rem", color: "#94a3b8", fontStyle: "italic" }}>Sem subcategorias</span>
          )}
        </TableCell>

        {/* Coluna 4: Editar */}
        <TableCell align="right">
          <Edit color="success" onClick={() => setEditId(row?.id)} style={{ cursor: "pointer" }} />
        </TableCell>

        {/* Coluna 5: Excluir */}
        <TableCell align="right" sx={{ width: "50px" }}>
          <DeleteOutline color="error" onClick={openModal} style={{ cursor: "pointer" }} />
        </TableCell>
      </TableRow>
    </>
  );
};
